import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["fetch"] = "metaFlightDetails/fetch";
    ActionTypes["fetchSuccess"] = "metaFlightDetails/fetchSuccess";
    ActionTypes["fetchError"] = "metaFlightDetails/fetchError";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    fetch: createAction(ActionTypes.fetch, () => ({
        payload: {}
    })),
    fetchSuccess: createAction(ActionTypes.fetchSuccess, (flight) => ({
        payload: { flight }
    })),
    fetchError: createAction(ActionTypes.fetchError, (error) => ({
        payload: { error }
    }))
};
